import React from "react";
import {
  Faq,
  Hero,
  NewseLatter1,
  NewseLatter2,
  Services
} from "../../components/component";
import Collection_category from "../../components/collectrions/collection_category";
import Meta from "../../components/Meta";

const Home_1 = (props) => {

  return (
    <>
      <Meta title="Bit5 Lending" />
      <main>
        <Hero />
        {/* <Bids /> */}
        {/* <Top_collection /> */}
        {/* <Tranding_category /> */}
        <Collection_category bgWhite={true} {...props} />
        <NewseLatter1 />
        <NewseLatter2 />

        {/* <Services /> */}
        {/* <Faq /> */}
      </main>
    </>
  );
};

export default Home_1;
